/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    sticky: "sticky-pos",
};
export const ICON_TYPES = {
    circle: "circle",
    square: "square",
    grip: "grip",
};
export const TEXT = {
    filterResults: "Filter results",
};
export const SLOTS = {
    menuActions: "menu-actions",
};
//# sourceMappingURL=resources.js.map
